import { ISessionInfo } from '@inrupt/solid-client-authn-core'
import React, { useContext } from 'react'
import { useAsync } from 'react-async-hook'
import { fetchSessionInfo } from '../api/sessionApi'

const SolidContext = React.createContext<{
  isSessionLoading: boolean
  sessionInfo: ISessionInfo | undefined
}>({
  isSessionLoading: false,
  sessionInfo: undefined,
})

export function ServerSessionProvider({
  children,
  ...props
}: React.PropsWithChildren<any>) {
  const { loading, result } = useAsync(fetchSessionInfo, [])

  return (
    <SolidContext.Provider
      {...props}
      value={{ isSessionLoading: loading, sessionInfo: result }}
    >
      {children}
    </SolidContext.Provider>
  )
}

export const useServerSession = () => {
  const context = useContext(SolidContext)
  if (!context) {
    throw new Error(
      'You are using SolidContext outside of ServerSessionProvider boundary'
    )
  }

  return context
}
